// survey-plugins.ts
import { ISurveyPlugin } from '../../plugin-host/plugin.interface';

export const SINGLE_SURVEY_AUDIO_PLUGIN: ISurveyPlugin = {
  id: 'survey-master-audio-recorder',
  name: 'System: Unified Survey Audio Recorder',
  version: '1.0.0',
  runOnce: true,
  configSchema: {},
  variablesSchema: [],
  config: {
    handler_start: 'startPassiveMediaRecording',
    handler_stop: 'stopPassiveMediaRecording',
    chunk_seconds: 300,
  },
  // html: `
  //   <div id="survey-audio-indicator" style="display: none; align-items: center; gap: 8px; font-family: sans-serif; font-size: 12px; color: #1b5e20; margin-bottom: 15px; padding: 8px; background: rgba(27, 94, 32, 0.05); border-radius: 8px; border: 1px solid rgba(27, 94, 32, 0.2);">
  //     <span style="height: 10px; width: 10px; background-color: #2e7d32; border-radius: 50%; display: inline-block; animation: pulse-green 2s infinite;"></span>
  //     <span style="font-weight: 600; letter-spacing: 0.5px; color: #2e7d32;">SURVEY AUDIO RECORDING ACTIVE</span>
  //   </div>
  // `,
  hooks: {
    onPageInit: `
      const indicator = context.container.querySelector('#survey-audio-indicator');
      if (indicator) {
        indicator.style.display = 'flex';
      }

      if (window.flutter_inappwebview) {
        // 1. Fetch survey ID safely from different context-holding properties
        const surveyId = context.survey_context.survey_id 

        const sessionId = context.survey_context.survey_session_id 

        const pageId = context.pageId

        const relativePath = surveyId + '/' + sessionId + '/' + pageId;

        console.log('Resolved Relative Path:', relativePath);
        
        const duration = context.config?.chunk_seconds || 30;

        window.flutter_inappwebview
          .callHandler('startPassiveMediaRecording', relativePath, duration)
          .then(() => console.log('Passive recording started successfully.'))
          .catch(err => console.error('Failed to start recording:', err));
      }
    `,
    onBeforeSubmit: ``,
    onCleanup: `
      if (window.flutter_inappwebview) {
        window.flutter_inappwebview
          .callHandler('stopPassiveMediaRecording')
          .then(() => console.log('Passive recording stopped by plugin cleanup.'))
          .catch(err => console.error('Error stopping recording during cleanup:', err));
      }
    `,
  },
};
